import {
    DoubleSide,
    Mesh,
    MeshPhongMaterial,
    PlaneGeometry,
    sRGBEncoding,
    TextureLoader,
} from "three";


const roarSrc = new URL("../assets/images/roar.png", import.meta.url).href;

let aspect = window.innerWidth / window.innerHeight;
let h = 500 / 200;
let w = h * aspect;


let roar: Mesh;

export function initRoar(scene: THREE.Scene) {

    let texture = new TextureLoader().load(roarSrc);
    texture.encoding = sRGBEncoding;
    roar = new Mesh(
        new PlaneGeometry(1, 1),
        new MeshPhongMaterial({
            map: texture,
            transparent: true,
            side: DoubleSide,
        })
    );
    roar.visible = false;
    roar.scale.set(0.1065, 0.08, 1);
    roar.position.set(-0.07, 0.13, -0.5);
    scene.add(roar);
}

export function toggleRoar(visible: boolean) {
    console.log(visible)
    roar.visible = visible;
}

